<template>
    <div class="columns" v-if="eventSettings.length > 0">
        <div class="column">
            <EventSettingDefinition
                v-for="(eventSetting, index) in eventSettings"
                :key="eventSetting.name"
                :event-id="eventId"
                v-model="eventSettings[index]"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, onMounted } from "vue";
    import EventSettingDefinition from "./EventSettingDefinition.vue";
    import eventSettingsApi, { SingleEventSetting } from "../../Api/eventSettingsApi";
    import { handleError } from "../../Common/errorHandler";

    interface Props {
        eventId: number;
    }

    const props = defineProps<Props>();

    const eventSettings = ref<SingleEventSetting[]>([]);

    const fetchEventSettings = (): Promise<void> => {
        return eventSettingsApi.listSettings(props.eventId).then(settings => {
            //TODO: Enable support for string type/datetime-local.
            eventSettings.value = settings.filter(setting => setting.type !== "string");
        });
    };

    onMounted(() => {
        fetchEventSettings().catch(handleError);
    });
</script>

<style scoped></style>
